import {Component} from "@/event/calendar/dom/Component.ts";
import {CalendarView} from "@/event/calendar/CalendarModel.ts";
import {ViewLabelComponent} from "@/event/calendar/all/ViewLabelComponent.ts";
import {DrawingContext} from "@/event/calendar/dom/DrawingContext.ts";
import {Rect} from "@/event/calendar/Shapes.ts";
import {ButtonBar, ButtonBarComponent} from "@/event/calendar/all/ButtonBarComponent.ts";
import {dc} from "@fd/editors/html/plugins/Keymap.ts";
import {HEADER_HEIGHT} from "@/event/calendar/Constants.ts";

const V_BLUR_SHIFT = 2;
const H_BLUR_SHIFT = 4;
export const WRAP_AT = 450;

export class ViewHeaderComponent extends Component {
	private view: CalendarView;
	private label: ViewLabelComponent;
	private navigation: ButtonBarComponent;
	private selector: ButtonBarComponent;
	private zoom: ButtonBarComponent;

	constructor(view: CalendarView) {
		super();
		this.view = view;
		this.label = new ViewLabelComponent();
		this.navigation = new ButtonBarComponent(this.createNavigationButtonBar());
		this.selector = new ButtonBarComponent(this.createSelectorButtonBar());
		this.zoom = new ButtonBarComponent(this.createZoomButtonBar());
		this.append(this.label);
		this.append(this.navigation);
		this.append(this.selector);
		this.append(this.zoom);
	}

	createZoomButtonBar():ButtonBar {
		return [
			{ id: "zoomIn", icon: "zoom-in" },
			{ id: "zoomOut", icon: "zoom-out" }
		];
	}

	createSelectorButtonBar():ButtonBar {
		return [
			{ id: "viewDays", title: "calendar.view.days", icon: "view-days", dropLabel: 600 },
			{ id: "viewWeeks", title: "calendar.view.weeks", icon: "view-weeks", dropLabel: 600 }
		];
	}

	createNavigationButtonBar():ButtonBar {
		return [
			{ id: "prev", icon: "caret-left-16" },
			{ id: "today", title: "bas.today" },
			{ id: "next", icon: "caret-right-16" }
		];
	}


	layoutSelf(dc: DrawingContext, contentBox: Rect) {
		// Widths of children are now known
		let spacing = 16;
		const w = contentBox.width;
		if (w < 500) spacing = 4;
		else if (w < 600) spacing = 8;
		this.navigation.y = this.selector.y = this.zoom.y = contentBox.y + V_BLUR_SHIFT;

		if (w < WRAP_AT) {
			// Place nav bar and label vertically
			this.zoom.x = 0;
			this.navigation.x = (contentBox.x + contentBox.width) - this.navigation.width - H_BLUR_SHIFT;
			this.selector.x = this.zoom.x + this.zoom.width + spacing;
			this.label.y = contentBox.y + HEADER_HEIGHT;
		} else {
			// Place horizontally
			this.navigation.x = (contentBox.x + contentBox.width) - this.navigation.width - H_BLUR_SHIFT;
			this.selector.x = this.navigation.x - this.selector.width - spacing;
			this.zoom.x = this.selector.x - this.zoom.width - spacing;
		}
	}


	draw(dc: DrawingContext, area: Rect) {
		this.label.range = this.view.focused ?? { start: this.view.selected, end: this.view.selected };
		this.label.viewType = this.view.current;
		super.draw(dc, area);
	}
}